import { GetRemoteLessonsFilterKey } from 'types';

export const remoteLessonFilterFields: Record<
    GetRemoteLessonsFilterKey,
    GetRemoteLessonsFilterKey
> = {
    startYear: 'startYear',
    endYear: 'endYear',
};
